import React from 'react';
import './Privacy.css';

const Privacy = () => {
  return (
    <div className="privacy">
      {/* Hero Section */}
      <section className="privacy-hero">
        <div className="container">
          <h1 className="page-title">개인정보처리방침</h1>
          <p className="hero-description">
            세무회계 결은 개인정보보호법에 따라 고객의 개인정보를 보호하고 있습니다.
          </p>
        </div>
      </section>

      {/* Privacy Content */}
      <section className="privacy-content">
        <div className="container">
          <div className="privacy-section">
            <h2>1. 개인정보의 처리목적</h2>
            <p>세무회계 결(이하 '회사')은 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 개인정보보호법 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.</p>
            <ul>
              <li>세무·회계 상담 서비스 제공</li>
              <li>고객 문의사항 처리 및 답변</li>
              <li>서비스 개선을 위한 통계 분석</li>
              <li>법정 의무 이행</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h2>2. 개인정보의 처리 및 보유기간</h2>
            <p>회사는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.</p>
            <ul>
              <li>상담 관련 개인정보: 상담 완료 후 3년</li>
              <li>계약 관련 개인정보: 계약 종료 후 5년</li>
              <li>세무 관련 서류: 관련 법령에 따라 10년</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h2>3. 처리하는 개인정보의 항목</h2>
            <p>회사는 다음의 개인정보 항목을 처리하고 있습니다.</p>
            <div className="info-category">
              <h4>상담 신청 시</h4>
              <ul>
                <li>필수항목: 성명, 연락처, 상담분야, 상담내용</li>
                <li>선택항목: 이메일 주소</li>
              </ul>
            </div>
            <div className="info-category">
              <h4>서비스 이용 시</h4>
              <ul>
                <li>사업자등록번호, 주소, 업종</li>
                <li>재무 관련 정보</li>
                <li>기타 세무·회계 업무 관련 정보</li>
              </ul>
            </div>
          </div>

          <div className="privacy-section">
            <h2>4. 개인정보의 제3자 제공</h2>
            <p>회사는 원칙적으로 정보주체의 개인정보를 수집·이용 목적으로 명시한 범위 내에서 처리하며, 정보주체의 사전 동의 없이는 본래의 목적 범위를 초과하여 처리하거나 제3자에게 제공하지 않습니다. 다만, 다음의 경우에는 예외로 합니다.</p>
            <ul>
              <li>정보주체로부터 별도의 동의를 받은 경우</li>
              <li>법률에 특별한 규정이 있거나 법령상 의무를 준수하기 위하여 불가피한 경우</li>
              <li>공공기관이 법령 등에서 정하는 소관 업무의 수행을 위하여 불가피한 경우</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h2>5. 개인정보처리의 위탁</h2>
            <p>회사는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.</p>
            <div className="info-category">
              <h4>이메일 발송 서비스</h4>
              <ul>
                <li>위탁받는 자: EmailJS</li>
                <li>위탁하는 업무의 내용: 상담 문의 이메일 전송</li>
                <li>위탁기간: 서비스 이용 기간</li>
              </ul>
            </div>
          </div>

          <div className="privacy-section">
            <h2>6. 정보주체의 권리·의무 및 행사방법</h2>
            <p>정보주체는 회사에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.</p>
            <ul>
              <li>개인정보 처리현황 통지요구</li>
              <li>개인정보 열람요구</li>
              <li>개인정보 정정·삭제요구</li>
              <li>개인정보 처리정지요구</li>
            </ul>
            <p>권리 행사는 회사에 대해 개인정보보호법 시행규칙 별지 제8호 서식에 따라 서면, 전화, 이메일을 통하여 하실 수 있으며 회사는 이에 대해 지체없이 조치하겠습니다.</p>
          </div>

          <div className="privacy-section">
            <h2>7. 개인정보의 파기</h2>
            <p>회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.</p>
            <div className="info-category">
              <h4>파기절차</h4>
              <p>불필요한 개인정보 및 개인정보파일은 개인정보보호책임자의 책임 하에 내부 방침 절차에 따라 다음과 같이 처리하고 있습니다.</p>
            </div>
            <div className="info-category">
              <h4>파기방법</h4>
              <ul>
                <li>전자적 파일 형태: 기록을 재생할 수 없도록 로우레벨포맷 등의 방법으로 파기</li>
                <li>종이 문서: 전문업체를 통한 문서 분쇄·파쇄</li>
              </ul>
            </div>
          </div>

          <div className="privacy-section">
            <h2>8. 개인정보의 안전성 확보조치</h2>
            <p>회사는 개인정보보호법 제29조에 따라 다음과 같이 안전성 확보에 필요한 기술적·관리적 및 물리적 조치를 하고 있습니다.</p>
            <ul>
              <li>개인정보 취급 직원의 최소화 및 교육</li>
              <li>개인정보에 대한 접근 제한</li>
              <li>접속기록의 보관 및 위변조 방지</li>
              <li>개인정보의 암호화</li>
              <li>보안프로그램 설치 및 갱신</li>
              <li>물리적 보관 장소의 접근통제</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h2>9. 개인정보 자동 수집 장치의 설치·운영 및 거부에 관한 사항</h2>
            <p>회사는 정보주체의 이용정보를 저장하고 수시로 불러오는 '쿠키(Cookies)'를 사용하지 않습니다.</p>
          </div>

          <div className="privacy-section">
            <h2>10. 개인정보 보호책임자</h2>
            <p>회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.</p>
            
            <div className="contact-info-grid">
              <div className="contact-card">
                <h4>서울본점</h4>
                <ul>
                  <li><strong>책임자:</strong> 세무회계 결 대표</li>
                  <li><strong>연락처:</strong> 02-6949-5003</li>
                  <li><strong>이메일:</strong> tax_gyeol@naver.com</li>
                  <li><strong>주소:</strong> 서울특별시 중랑구 망우로 177, 3층</li>
                </ul>
              </div>
              
              <div className="contact-card">
                <h4>울산지점</h4>
                <ul>
                  <li><strong>책임자:</strong> 세무회계 결 울산지점장</li>
                  <li><strong>연락처:</strong> 052-700-5003</li>
                  <li><strong>이메일:</strong> cta9321@kakao.com</li>
                  <li><strong>주소:</strong> 울산광역시 중구 종가6길 21, 9층</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="privacy-section">
            <h2>11. 개인정보 처리방침 변경</h2>
            <p>이 개인정보처리방침은 2025년 9월 11일부터 적용됩니다. 이전의 개인정보처리방침은 아래에서 확인하실 수 있습니다.</p>
            <ul>
              <li>적용일자: 2025년 9월 11일</li>
              <li>공고일자: 2025년 9월 11일</li>
            </ul>
          </div>

          <div className="privacy-section contact-section">
            <h2>개인정보 관련 문의</h2>
            <p>개인정보 처리방침에 대한 문의사항이 있으시면 아래 연락처로 연락해주시기 바랍니다.</p>
            <div className="contact-methods">
              <div className="contact-method">
                <strong>전화:</strong> 02-6949-5003 (서울본점)
              </div>
              <div className="contact-method">
                <strong>이메일:</strong> tax_gyeol@naver.com
              </div>
              <div className="contact-method">
                <strong>주소:</strong> 서울특별시 중랑구 망우로 177, 3층 (중화동, 삼성빌딩)
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;
